import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";

const STATUSES = ["open", "under_review", "resolved", "dismissed"];

export default function AdminVehicleIssues() {
  const [issues, setIssues] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/vehicle-issues");
      setIssues(data || []);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  useEffect(() => { load(); }, []);

  const update = async (issue, status, blockVehicle = false) => {
    try {
      await api.patch(`/admin/vehicle-issues/${issue.id}`, { status, block_vehicle: blockVehicle });
      toast.success("Issue updated");
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-vehicle-issues-page">
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight">Vehicle Issues</h1>
        <p className="text-sm text-slate-500">Review driver-reported incidents and maintenance notes.</p>
      </div>
      <div className="space-y-4">
        {issues.map((issue) => (
          <div key={issue.id} className="rounded-xl border border-slate-200 bg-white p-5">
            <div className="flex items-start justify-between gap-3">
              <div>
                <h2 className="font-heading text-xl font-semibold tracking-tight text-slate-900">{issue.title || issue.issue_type.replace(/_/g, " ")}</h2>
                <p className="mt-1 text-sm text-slate-500">Severity: {issue.severity}</p>
              </div>
              <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-700 ring-1 ring-inset ring-slate-200">{issue.status}</span>
            </div>
            <p className="mt-4 text-sm text-slate-600">{issue.description || "No description provided."}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {STATUSES.map((status) => (
                <button key={status} onClick={() => update(issue, status)} data-testid={`admin-issue-status-${issue.id}-${status}`} className="rounded-md border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50">
                  {status}
                </button>
              ))}
              {issue.severity === "critical" && (
                <button onClick={() => update(issue, "under_review", true)} data-testid={`admin-issue-block-vehicle-${issue.id}`} className="rounded-md border border-red-300 bg-red-50 px-3 py-2 text-xs font-semibold text-red-800">
                  Block vehicle
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}